import { type ImageAsset, type Image as SanityImage } from '@sanity/types';

// Image that doesn't have a fully dereferenced asset field.
export type UnexpandedImage = SanityImage & {
	alt?: string;
	credit?: string;
};

// Image with fully dereferenced asset field (from a GROQ query), used in places where we need to access asset properties.
export type ExpandedImage = UnexpandedImage & {
	asset: ImageAsset;
};

export type Image = ExpandedImage | UnexpandedImage;

export type Pallette = {
	_type: string;
	background: string;
	foreground: string;
	population: number;
	title: string;
};

export type BreadcrumbSegment = {
	name: string;
	path?: string; // The last segment doesn't need a path since you're already on the page.
};

// Type guard to make TypeScript happy when working with images since the asset field can be either fully dereferenced
// or not depending on the query used.
export function isExpandedImage(image: Image): image is ExpandedImage {
	return image.asset?._type === 'sanity.imageAsset';
}
